import React, { useContext, useState, useEffect } from 'react';

import { Box, Grow, Grid } from '@material-ui/core';
import { useDispatch } from 'react-redux';
import { useHistory } from 'react-router-dom';
import styled from 'styled-components';
import { StyledTypography, VerticalFlexContainer } from 'styles/common';

import oneOnOneImage from 'assets/images/illustrations/oneOnOne.png';
import CreateOneOnOneImage from 'assets/images/illustrations/oneOnOneCreateTransparentBackground.png';

import { TASK_TYPES_2, MESH_LIST_TABS, APP_SOURCE_CONTAINERS } from 'constants/ProjectConstants';
import { goToOneOnOneInstancePage } from 'constants/helper';
import { sendOpenedOneOnOneSidePanelEvent } from 'constants/mixpanelHelper';

import { getStatsForEmployee } from 'services/OneOnOne';
import { showErrorSnackbar } from 'services/snackbar';

import LoadMore from '../LoadMore';
import MeshListContext from '../MeshListContext';
import TasksGoalsContainer from '../TasksGoalsContainer';
import NoTasksComponent from '../tasks/NoTasksComponent';
import CheckInListCard from './CheckInListCard';

const REFERRER = 'MeshList';

const StyledImage = styled.img`
  max-width: 100%;
  margin-top: 40px;
  margin-left: -20px;
`;

const BannerWrapper = styled.div`
  background: #f4faff;
  padding: 1.5rem 0 1.5rem 1.5rem;
`;

export const TopBanner = ({ employee, sourceContainer = APP_SOURCE_CONTAINERS.WEB_APP }) => {
  const [delayedCount, setDelayedCount] = useState('-');
  const [completedCount, setCompletedCount] = useState('-');
  const isPlugin = sourceContainer === APP_SOURCE_CONTAINERS.PLUGIN;

  const dispatch = useDispatch();

  useEffect(() => {
    getStatsForEmployee({ employeeId: employee.id })
      .then((res) => {
        setDelayedCount(res.delayed);
        setCompletedCount(res.completed);
      })
      .catch((err) => {
        dispatch(showErrorSnackbar(err?.message || 'Failed to fetch stats'));
        console.error(err);
      });
  }, []);

  return (
    <BannerWrapper>
      <Grid container>
        <Grid item xs={7}>
          <VerticalFlexContainer justifycontent="space-between">
            <div>
              <StyledTypography
                style={{ fontSize: isPlugin ? '16px' : '20px' }}
                variant="h6"
                customColor="#0B4870"
                weight={600}
                bottomGutter={1}
              >
                Complete your
              </StyledTypography>
              <StyledTypography
                style={{ fontSize: isPlugin ? '16px' : '20px' }}
                variant="h6"
                customColor="#0B4870"
                weight={600}
                bottomGutter={3.5}
              >
                1:1s
              </StyledTypography>
            </div>
            <div>
              {/* stats */}
              <Grid container>
                <Grid item xs={6}>
                  <StyledTypography
                    style={{ fontSize: isPlugin ? '16px' : '20px' }}
                    variant="h6"
                    customColor="#7A96A8"
                    weight={600}
                  >
                    {delayedCount}
                  </StyledTypography>
                </Grid>
                <Grid item xs={6}>
                  <StyledTypography
                    style={{ fontSize: isPlugin ? '16px' : '20px' }}
                    variant="h6"
                    customColor="#7A96A8"
                    weight={600}
                  >
                    {completedCount}
                  </StyledTypography>
                </Grid>
              </Grid>
              <Grid container>
                <Grid item xs={6}>
                  <StyledTypography variant="caption" customColor="#46678B">
                    Delayed
                  </StyledTypography>
                </Grid>
                <Grid item xs={6}>
                  <StyledTypography variant="caption" customColor="#46678B">
                    Completed
                  </StyledTypography>
                </Grid>
              </Grid>
              {/* stats -- end */}
            </div>
          </VerticalFlexContainer>
        </Grid>
        {/* image */}
        <Grid item xs={5}>
          <StyledImage src={oneOnOneImage} />
        </Grid>
      </Grid>
    </BannerWrapper>
  );
};

export default function CheckIns({ tasks, pageType, employee, setIsOneOnOnePanelOpen = () => {} }) {
  const { selectedTab, apiPaginationMeta, dispatch, selectedTeamsPageView = null } = useContext(MeshListContext);
  const isCheckInsTabSelected = selectedTab === MESH_LIST_TABS.checkIn.id;
  const reduxDispatch = useDispatch();
  const history = useHistory();

  const showDetails = (taskId, e) => {
    if (e) e.stopPropagation();

    goToOneOnOneInstancePage(history, taskId, REFERRER);
    sendOpenedOneOnOneSidePanelEvent({
      eventProperties: {
        source: pageType,
      },
    });
  };

  if (tasks?.length === 0 && isCheckInsTabSelected) {
    return (
      <NoTasksComponent
        img={CreateOneOnOneImage}
        heading="No 1:1s yet"
        subHeading="Schedule your next 1:1 to setup periodic conversations with your manager, team or frequent collaborators."
        onButtonClick={() => setIsOneOnOnePanelOpen(true)}
        buttonText="Create 1:1"
      />
    );
  }

  return isCheckInsTabSelected ? (
    <TasksGoalsContainer>
      <TopBanner employee={employee} />
      {tasks.map((task, index, taskArray) => {
        const lastItem = index + 1 === taskArray.length;
        return (
          <Grow style={{ marginBottom: lastItem ? '80px' : 0 }} in key={`checkIn${task.id || task.key}`}>
            <CheckInListCard
              key={`task${task.id}`}
              task={task}
              employee={employee}
              onClickHandler={(e) => showDetails(task.id, e)}
            />
          </Grow>
        );
      })}
      {apiPaginationMeta?.hasMore && (
        <div>
          <Box position="absolute" bottom={0} width="100%" borderTop="1px solid lightgrey" textAlign="center">
            <LoadMore type={TASK_TYPES_2.checkIn} pageType={pageType} />
          </Box>
        </div>
      )}
    </TasksGoalsContainer>
  ) : null;
}
